import classNames from 'classnames';
import type { HTMLAttributes } from 'react';

import styles from './Spinner.module.css';

type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export interface SpinnerProps extends HTMLAttributes<HTMLDivElement> {
  size?: SpinnerSize;
  label?: string;
}

export const Spinner = ({
  size = 'md',
  label = 'Loading…',
  className,
  ...rest
}: SpinnerProps) => (
  <div
    className={classNames(styles.spinner, styles[size], className)}
    role="status"
    aria-live="polite"
    {...rest}
  >
    <span className={styles.srOnly}>{label}</span>
  </div>
);
